import React from 'react'
import uuid from 'react-uuid'
import { Input, Label } from 'reactstrap'
import { INPUT_TYPES } from '../../Constants/MainKeys'

export default function BankAccountInput({
  id = uuid(),
  labelValue = "",
  type = "text",
  value = "",
  placeholder = "",
  required = false,
  pattern = ".*",
  error = false,
  errorMessage = "",
  disabled = false,
  onChange = () => { }
}) {
  return (
    <React.Fragment>
      <Label htmlFor={id} className={`text-muted text-truncate mb-0`}>{labelValue}{required ? "*" : ""}</Label>
      <Input
        id={id}
        type={INPUT_TYPES.includes(type) ? type : "text"}
        placeholder={placeholder}
        pattern={pattern}
        className={`${error ? "error-border" : ""}`}
        value={value}
        required={required}
        onChange={onChange}
        disabled={disabled}
      />
      <div className={`d-${errorMessage && error ? "block" : "none"}`}><small className='text-danger'>{errorMessage}</small></div>
    </React.Fragment>
  )
}
